import React, {Component} from 'react';
import {gpn} from "../../GPN"
import PostEditor from "../sections/PostEditor";
import axios from "axios";
import config from "../../config";
import {toast} from "react-toastify";
import {EditorState} from "draft-js";
import ContentState from "draft-js/lib/ContentState";
import Modal from "../sections/Modal";
import Fab from "../sections/Fab";

class Terms extends Component {

    state = {
        terms: "",

        uploadModal: false,
        img: null,
        uploadUrl: ""
    };

    componentDidMount() {
        this.getTerms();
    }

    getTerms() {
        axios.get(`${config.apiV1}/terms`)
            .then(r => {
                this.setState({terms: r.data.terms ? r.data.terms : ""});
            })
            .catch(err => {
                console.error(err);
            });
    }

    setTerms() {
        const {terms} = this.state;
        let params = new URLSearchParams();
        params.append('content', terms);
        axios.post(`${config.api}/terms?token=${config.token}`, params)
            .then(r => {
                toast.success("با موفقیت ذخیره شد.");
                this.getTerms();
            })
            .catch(err => {

            });
    }

    uploadImage(img) {
        if (img) {
            toast.success("در حال آپلود ...")
            let params = new FormData();
            params.append('img', img);

            axios.post(`${config.api}/upload/image?token=${config.token}`, params, {
                header: {
                    'content-type': 'multipart/form-data'
                }
            })
                .then(r => {
                    this.setState({uploadUrl: r.data.url});
                    toast.success("با موفقیت آپلود شد.")
                })
                .catch(err => {
                    toast.error("خطا!")
                });
        }
    }


    render() {
        const {terms, uploadUrl} = this.state;
        return (
            <div className="terms">
                <PostEditor
                    wrapperClassName="wrapper-class"
                    editorClassName="editor-class"
                    content={terms}
                    editorState={EditorState.createWithContent(ContentState.createFromText(terms))}
                    onChange={(e) => {
                        this.setState({terms: e})
                    }}
                    toolbarClassName="toolbar-class"
                />
                <div className="row">
                    <div className="col-md-6">
                        <button type="button" onClick={this.setTerms.bind(this)}>ذخیره</button>
                    </div>
                </div>
                <Fab icon="cloud_upload" size={14} onClick={() => {
                    this.setState({
                        uploadModal: true
                    })
                }}/>
                <Modal show={this.state.uploadModal}
                       title="آپلود عکس"
                       onCloseClick={() => {
                           this.setState({
                               uploadModal: false
                           })
                       }}>
                    <div className="form-control">
                        <label htmlFor="img">عکس:</label>
                        <input type="file"
                               name="img"
                               id="img"
                               onChange={(e) => {
                                   const {files} = e.target;
                                   const arrFiles = Array.from(files);

                                   this.setState({
                                       img: arrFiles[0]
                                   });
                                   this.uploadImage(arrFiles[0])
                               }}/>
                        {
                            uploadUrl !== "" ?
                                <input type="text" name="uploadUrl" id="uploadUrl" value={uploadUrl}/>
                                : null
                        }
                    </div>
                </Modal>
            </div>
        );
    }
}

export default gpn(Terms);